module.exports = __webpack_public_path__ + "img/pageBanner-wonderfulExample.374802d2.jpg";